import React from 'react';
import { useParams } from 'react-router';
import CreateUserSettings from './CreateUserSettings';
import UpdateUserSettings from './UpdateUserSettings';
const UserSettings = (props) => {
    const params = useParams();
    const userId = props.userId || params.userId;
    return (React.createElement(React.Fragment, null, userId ? (React.createElement(UpdateUserSettings, { userId: userId })) : (React.createElement(CreateUserSettings, null))));
};
export default UserSettings;
//# sourceMappingURL=UserSettings.js.map